import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=4af0a9da"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af0a9da')) {
      api.createRecord('4af0a9da', component.options)
    } else {
      api.reload('4af0a9da', component.options)
    }
    module.hot.accept("./configDialog.vue?vue&type=template&id=4af0a9da", function () {
      api.rerender('4af0a9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelCode/components/configDialog.vue"
export default component.exports